import { useRedirect } from "@wff/libs/i18n/redirect";

const Index = () => {
  useRedirect();
  return <></>;
};

export default Index;
